module.exports = __webpack_public_path__ + "img/ico_hotel.7166224b.png";